// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__wtlzi","label":"CategoryService_label__G6nId","location":"CategoryService_location__1wKVt"};